import { usePropertyRepository } from '@app/land-hold/property/repositories/usePropertyRepository';
import type { Ref } from 'vue';

export function useAvailableVersionYears(propertyId: string): {
    years: Ref<number[]>;
    fetchingYears: Ref<boolean>;
    error: Ref<string | null>;
} {
    const years: Ref<number[]> = ref([]);
    const fetchingYears = ref(true);
    const error = ref<string | null>(null);

    const { endpoint } = usePropertyRepository().query.availableVersionYears(propertyId);

    window.axios
        .get<{ data: number[] }>(endpoint)
        .then(({ data }) => {
            years.value = data.data;
        })
        .catch(() => {
            error.value = 'Failed to load available years. Please reload the page.';
        })
        .finally(() => {
            fetchingYears.value = false;
        });

    return { years, fetchingYears, error };
}
